export default {"src":"/_next/static/media/GLW.744fcd9d.svg","height":18,"width":18};